import { LocationMapWithProvider } from "@features/map";

import { LocationMapCardLayout } from "@shared/ui/location-map-card-layout";
import { MapDetails } from "@shared/ui/map-details";

import type { LocationMapType } from "./model/schema";

export const ContactMapCard = (content: LocationMapType) => {
  const {
    title,
    locationName,
    coordinates,
    phone,
    email1,
    email2,
    socialLinks,
    workTimeList,
    description,
    ctaButton,
    onButtonClick,
  } = content;

  return (
    <LocationMapCardLayout
      title={title || ""}
      button={ctaButton}
      description={description || ""}
      map={coordinates && <LocationMapWithProvider coordinates={coordinates} />}
      onButtonClick={onButtonClick}
    >
      <MapDetails
        location={locationName}
        phone={phone}
        emails={[email1, email2]}
        socialLinks={socialLinks}
        linkifyContacts
        formatPhone
        showWorkingHoursIcon={false}
        workTimeList={workTimeList}
      />
    </LocationMapCardLayout>
  );
};
